<template>
  <div class='c-tag'>{{ text }}
    <CButtonClose
        @click="$emit('remove-selected', value)"
    />
  </div>
</template>

<script>

import CButtonClose from '../button/CButtonClose'

const props = {
  text: String,
  value: String,
}

export default {
  name: 'CMultiSelected',
  props,
  components: {
    CButtonClose
  },
}

</script>
